import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/snow-removal-highland-ut")({
  beforeLoad: () => {
    throw redirect({
      href: "/services/snow-removal",
      statusCode: 301,
    });
  },
});
